import React, { Component } from 'react';
import ToastItem from './ToastItem';
import 'bootstrap/dist/css/bootstrap.css';

class ToastPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toastArray: []
        }
    }

    callback = (obj) => {
        this.props.log('ToastPanel.js/callback (obj)', obj);
        this.setState((prevState, props) => {
            let sel = [...prevState.toastArray];
            sel.push({ str: obj.str, delay: obj.delay, color: obj.color, id: Math.random() })
            return { toastArray: sel };
        });
    }

    onDelete = (id) => {
        this.props.log('ToastPanel.js/onDelete (id)',id);
        this.setState((prevState) => {
            let sel = [...prevState.toastArray];
            const index = sel.findIndex(item => item.id === id);
            if (index > -1) sel.splice(index,1);
            return { toastArray: sel };
        });
    }

    componentDidMount() {
        this.props.log('ToastPanel.js/componentDidMount');
        this.props.addCallback(this.callback)
    }

    render() {
        this.props.info('ToastPanel.js/render');
        return (
            <>{this.state.toastArray.map(toast => (
                <ToastItem
                    key={toast.id}
                    toast={toast}
                    onDelete={this.onDelete}
                    log={this.props.log}
                    info={this.props.info}
                />
            ))}</>
        )
    }
};

export default ToastPanel;